// import Swiper from 'swiper';
// import 'remodal';

// ナビゲーションアニメーション;
const funcNav = () => {
	const myMain = document.querySelectorAll('.area');
	const navItems = document.querySelectorAll('.side nav li');

	if (myMain.length === 0 || navItems.length === 0) {
		return;
	}

	const mainArray = Array.from(myMain);
	const observeAction = (entries) => {
		entries.forEach((entry) => {
			const index = mainArray.indexOf(entry.target);
			if (index === -1) return;

			if (entry.isIntersecting) {
				// すべてのnavItemsからactiveを削除
				navItems.forEach((item) => item.classList.remove('active'));
				// 現在の要素に対応するnavItemにactiveを追加
				if (navItems[index]) {
					navItems[index].classList.add('active');
				}
			} else {
				if (navItems[index]) {
					navItems[index].classList.remove('active');
				}
			}
		});
	};

	const options = {
		rootMargin: '0px 0px -90% 0px',
		threshold: 0,
	};

	const observer = new IntersectionObserver(observeAction, options);

	myMain.forEach((target) => {
		observer.observe(target);
	});
};

// スクロールアニメーション;
const funcAnim = () => {
	const progressItems = document.querySelectorAll('.anim');

	if (progressItems.length === 0) {
		return;
	}

	const observeAction = (entries) => {
		entries.forEach((entry) => {
			if (entry.isIntersecting) {
				entry.target.classList.add('active');
			}
			// else {
			// 	// console.log('こない');
			// 	entry.target.classList.remove('active');
			// }
		});
	};

	const options = {
		rootMargin: '0px 0px -10% 0px',
		threshold: 0,
	};

	const observer = new IntersectionObserver(observeAction, options);

	progressItems.forEach((target) => {
		observer.observe(target);
	});
};

// スムーススクロール
const Ease = {
	easeInOut: (t) => (t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1),
};
const duration = 500;

window.addEventListener('DOMContentLoaded', () => {
	const smoothScrollTriggers = document.querySelectorAll('.anchor');
	const myMain = document.querySelectorAll('.area');
	const navItems = document.querySelectorAll('.side nav li');
	const mainArray = Array.from(myMain);

	smoothScrollTriggers.forEach((smoothScrollTrigger) => {
		smoothScrollTrigger.addEventListener('click', (e) => {
			const href = smoothScrollTrigger.getAttribute('href');
			if (!href || !href.startsWith('#')) return;

			const targetId = href.slice(1);
			if (!targetId) return;

			const targetElement = document.getElementById(targetId);
			if (!targetElement) return;

			e.preventDefault();
			e.stopPropagation();

			const currentPosition = window.scrollY || document.documentElement.scrollTop || document.body.scrollTop || 0;
			const targetPosition = currentPosition + targetElement.getBoundingClientRect().top - 0;
			const distance = targetPosition - currentPosition;
			const startTime = performance.now();

			const loop = (nowTime) => {
				const time = nowTime - startTime;
				const normalizedTime = time / duration;

				if (normalizedTime < 1) {
					window.scrollTo(0, currentPosition + distance * Ease.easeInOut(normalizedTime));
					requestAnimationFrame(loop);
				} else {
					window.scrollTo(0, targetPosition);

					// funcNav等要素を取る時（発火位置調整）
					setTimeout(() => {
						const index = mainArray.indexOf(targetElement);
						if (index !== -1 && navItems[index]) {
							navItems.forEach((item) => item.classList.remove('active'));
							navItems[index].classList.add('active');
						}
					}, 200); // IntersectionObserverの更新を待つ
				}
			};

			requestAnimationFrame(loop);
		});
	});

	// GSAP ScrollTrigger
	// const targetTrigger = document.querySelector('.scrolltrigger');
	// if (targetTrigger && typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
	// 	gsap.registerPlugin(ScrollTrigger);

	// 	gsap
	// 		.timeline({
	// 			scrollTrigger: {
	// 				trigger: targetTrigger,
	// 				start: 'top top+=50',
	// 				end: '+=3000',
	// 				pin: true,
	// 				// scrub: true,
	// 				scrub: 2, // 滑らかさ
	// 			},
	// 		})
	// 		.to('.target-image1', { duration: 2, autoAlpha: 0, delay: 4, ease: 'sine.inOut' })
	// 		.from('.target-image2', { duration: 2, autoAlpha: 0, ease: 'sine.inOut' }, '-=2')
	// 		.from('.target-image3', { duration: 2, autoAlpha: 0, delay: 4, ease: 'sine.inOut' })
	// 		.from('.target-image4', { duration: 2, autoAlpha: 0, delay: 4, ease: 'sine.inOut' })
	// 		.from('.target-image5', { duration: 2, autoAlpha: 0, delay: 4, ease: 'sine.inOut' })
	// 		.from('.target-image6', { duration: 2, autoAlpha: 0, delay: 4, ease: 'sine.inOut' })
	// 		.to({}, { duration: 6 }); // image6 を長く表示
	// }

	// GSAP ScrollTrigger（scrub + スクロールアップ時に無効化）
	const targetTrigger = document.querySelector('.scrolltrigger');
	if (targetTrigger && typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
		gsap.registerPlugin(ScrollTrigger);

		const START_OFFSET = 50;
		const SCROLL_DISTANCE = 3000;
		const SCRUB_SMOOTHNESS = 2;
		let mainScrollTrigger = null;
		let reactivationTrigger = null;
		let scrollUpHandled = false;

		const createReactivationTrigger = () => {
			if (reactivationTrigger) reactivationTrigger.kill();
			reactivationTrigger = ScrollTrigger.create({
				trigger: targetTrigger,
				start: 'top bottom',
				once: true,
				onEnter: () => {
					if (mainScrollTrigger) {
						mainScrollTrigger.enable();
						scrollUpHandled = false;
						ScrollTrigger.refresh();
					}
				},
			});
		};

		gsap
			.timeline({
				scrollTrigger: {
					trigger: targetTrigger,
					start: `top top+=${START_OFFSET}`,
					end: `+=${SCROLL_DISTANCE}`,
					pin: true,
					scrub: SCRUB_SMOOTHNESS,
					onUpdate: (self) => {
						if (self.direction === -1) {
							if (scrollUpHandled) return;
							scrollUpHandled = true;
							mainScrollTrigger = self;
							self.disable(false);
							window.scrollTo(0, self.start);
							requestAnimationFrame(() => {
								ScrollTrigger.refresh();
								createReactivationTrigger();
							});
						}
					},
				},
			})
			.to('.target-image1', { duration: 2, autoAlpha: 0, delay: 4, ease: 'sine.inOut' })
			.from('.target-image2', { duration: 2, autoAlpha: 0, ease: 'sine.inOut' }, '-=2')
			.from('.target-image3', { duration: 2, autoAlpha: 0, delay: 4, ease: 'sine.inOut' })
			.from('.target-image4', { duration: 2, autoAlpha: 0, delay: 4, ease: 'sine.inOut' })
			.from('.target-image5', { duration: 2, autoAlpha: 0, delay: 4, ease: 'sine.inOut' })
			.from('.target-image6', { duration: 2, autoAlpha: 0, delay: 4, ease: 'sine.inOut' })
			.to({}, { duration: 6 }); // image6 を長く表示
	}

	// スクロールアニメーション;
	funcAnim();

	// ナビゲーションアニメーション;
	funcNav();
});
